var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"x-small":"","elevation":0},on:{"click":_vm.handleShowPDF}},[_vm._v(" "+_vm._s(_vm.$t('folders.showPDF', _vm.locale))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }